import { render } from "./AdvisorDetails.vue?vue&type=template&id=8334ab92"
import script from "./AdvisorDetails.vue?vue&type=script&lang=js"
export * from "./AdvisorDetails.vue?vue&type=script&lang=js"

import "./AdvisorDetails.vue?vue&type=style&index=0&id=8334ab92&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__